import type { SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

import baselineSvg from "./max-icon.baseline.svg?react";
import textSvg from "./max-icon.text.svg?react";
import { makeSvgIcon } from "./svg-icon";

const MaxIconBaseline = makeSvgIcon(baselineSvg);
const MaxIconText = makeSvgIcon(textSvg);

export const MaxIcon = forwardRef(function (
  { text = true, ...props }: SvgIconProps & { text?: boolean },
  ref: React.Ref<SVGSVGElement>,
) {
  return text ? (
    <MaxIconText {...props} ref={ref} />
  ) : (
    <MaxIconBaseline {...props} ref={ref} />
  );
});

export default MaxIcon;
